export default __webpack_public_path__ + "static/media/talkaboutit.7ecea4f8.jpg";